import { Controller } from "@hotwired/stimulus";
import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = {
    images: { type: Array, default: [] },
    download: { type: Boolean, default: true },
  };

  disconnect() {
    if (this.lightGallery) {
      this.lightGallery.destroy();
    }
  }

  open({ params: { index = 0 } }) {
    if (!this.lightGallery) {
      this.lightGallery = lightGallery(this.element, {
        plugins: [lgZoom, lgThumbnail],
        licenseKey: "D0466584-0CA0-4146-92A1-2EE8C26ACE94", // Hard-coded as it will be public on the F/E anyways
        download: this.downloadValue,
        dynamic: true,
        dynamicEl: this.imagesValue,
        preload: 1,
        thumbnail: true,
      });

      // Update all visible bootstrap modals to ignore keyboard inputs (e.g. Escape to close) when gallery is open
      this.element.addEventListener("lgAfterOpen", (event) => {
        document.querySelectorAll(".modal.show").forEach((modalEl) => {
          const modalInstance = Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance._config.keyboard = false;
          }
        });
      });
      this.element.addEventListener("lgAfterClose", function () {
        document.querySelectorAll(".modal.show").forEach((modalEl) => {
          const modalInstance = Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance._config.keyboard = true;
          }
        });
      });
    }

    this.lightGallery.openGallery(index);
  }
}
